const search = {
  search: {
    title: 'Hospedagens disponíveis em Urubici',
    sortRecommended: 'Recomendados',
    sortPriceLow: 'Menor preço',
    sortPriceHigh: 'Maior preço',
    sortRating: 'Melhor avaliação',
    available: 'disponíveis',
    nightSingular: 'noite',
    nightPlural: 'noites',
    guestSingular: 'hóspede',
    guestPlural: 'hóspedes',
    propertySingular: 'propriedade',
    propertyPlural: 'propriedades',
    unitSingular: 'unidade',
    unitPlural: 'unidades',
    reviewSingular: 'avaliação',
    reviewPlural: 'avaliações',
    changeDates: 'Alterar datas',
    viewAvailability: 'Ver disponibilidade',
    from: 'a partir de',
    perNightTotal: '/ noite · total',
    availableUnitSingular: 'disponível',
    availableUnitPlural: 'disponíveis',
    realTimePrices: 'Preços e disponibilidade em tempo real via Reserve Connect.',
    loadingSearch: 'Buscando hospedagens disponíveis...',
    errorTitle: 'Não foi possível buscar',
    errorMessage: 'O serviço de disponibilidade está indisponível no momento. Tente novamente em alguns instantes.',
    noResultsTitle: 'Nenhuma hospedagem disponível',
    noResultsDesc: 'Não encontramos propriedades disponíveis para as datas selecionadas.',
    noResultsHint: 'Tente alterar as datas ou fale com nossa Central de Reservas.',
    pageTitle: 'Hospedagens disponíveis em Urubici - Reserve Connect',
    pageDescription: 'Encontre hospedagens disponíveis em Urubici, SC para {{checkIn}} a {{checkOut}}. Preços reais e disponibilidade confirmada.',
    breadcrumbSearch: 'Buscar',
  },
};
export default search;
